import { render, staticRenderFns } from "./consumptionCarousel.vue?vue&type=template&id=40fc31d4&scoped=true&"
import script from "./consumptionCarousel.vue?vue&type=script&lang=js&"
export * from "./consumptionCarousel.vue?vue&type=script&lang=js&"
import style0 from "./consumptionCarousel.vue?vue&type=style&index=0&id=40fc31d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc31d4",
  null
  
)

export default component.exports